export default "__VITE_ASSET__CrEgKC5t__"